<template>
    <div class="copd-table">
        <div class="copd-tbl-header">
            <div class="copd-tbl-col" v-for="header in tableData.headers">{{header}}</div>
        </div>
    <transition-group name="slide" appear>
        <div class="copd-tbl-row" v-for="item in tableData.items" v-bind:key="item.id" v-bind:class="item.class" v-if="item.show">
            <div class="copd-tbl-col" v-for="(col, i) in item.cols" v-bind:key="i"><span v-if="col">{{col}}</span></div>
        </div>
    </transition-group>
    </div>
</template>

<script>
    export default {
        name: 'COPD-Table',
        props: [ 'tableData' ]
    }
</script>

<style scoped lang="stylus">
    .copd-table
        width: 80%
        .copd-tbl-header, .copd-tbl-row
            display: flex
            padding-left: 2em
        .copd-tbl-header
            font-weight: 100
            color: #777
            margin-top: 1.75em
        .copd-tbl-row
            color: #fff
            font-weight: bold
            border-radius: 0 10em 10em 0
            margin-top: 0.75em
            margin-bottom: 2.2em
            padding-top: 0.9em
            padding-bottom: 0.9em
            line-height: 1em
            transition: transform 1s
            &.row-a
                background: #48c2ca
            &.row-b
                background: #efb16f
            &.row-c
                background: #89dc5b
            &.row-d
                background: #e990f4
    .slide-enter, .slide-leave-to
        transform: translateX(-100%)
</style>